import { Component, Input, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Breadcrumb } from 'primeng/breadcrumb';

// @Utils
import { Observable } from 'rxjs';

// @Services
import { BreadcrumbsService } from './breadcrumbs.service';

// @PrimeNG
import { MenuItem } from 'primeng/api';
import { NavigationEnd, Router } from '@angular/router';
import { Constants, CRUMBS } from '../../_utility';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: true,
  imports: [Breadcrumb, AsyncPipe],
})
export class BreadcrumbsComponent implements OnInit {
  @Input() flag: any = { label: 'Home', routerLink: ['/home'] };
  crumbs$!: Observable<any>;
  home!: MenuItem;

  constructor(private breadcrumb: BreadcrumbsService) {}

  ngOnInit() {
    this.crumbs$ = this.breadcrumb.crumbs$;
    this.home = this.flag;
  }
}
